import { defineStore } from "pinia";
import type GatheringFeedPublic from "~/pages/gathering/feed/gathering-feed-public.dto";
import type GatheringPublic from "~/pages/gathering/gathering-public.dto";

export const useIndexStore = defineStore("index", {
  state: () => ({
    gatheringListEnergy: [] as GatheringPublic[],
    gatheringListCommunication: [] as GatheringPublic[],
    gatheringListRanking: [] as GatheringPublic[],
    gatheringFeedList: [] as GatheringFeedPublic[],
  }),
  actions: {
    setGatheringListEnergy(list: GatheringPublic[]) {
      this.gatheringListEnergy = list;
    },
    setGatheringListCommunication(list: GatheringPublic[]) {
      this.gatheringListCommunication = list;
    },
    setGatheringListRanking(list: GatheringPublic[]) {
      this.gatheringListRanking = list;
    },
    setGatheringFeedList(list: GatheringFeedPublic[]) {
      this.gatheringFeedList = list;
    },
  },
  getters: {
    getGatheringListEnergy(state) {
      return [...state.gatheringListEnergy];
    },
    getGatheringListCommunication(state) {
      return [...state.gatheringListCommunication];
    },
    getGatheringListRanking(state) {
      return [...state.gatheringListRanking];
    },
    getGatheringFeedList(state) {
      return [...state.gatheringFeedList];
    },
  },
});
